/**
 * characterSheets — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {LANDSCAPE, tagline, chips, type ToilePack} from './data'

export const characterSheetsPack: ToilePack = {
    slug: 'character-sheets',
    category: 'charsheet',
    name: 'Character reference sheets',
    tagline: tagline('sheets', 'characters', 'layouts'),
    chips: chips('characters', 'layouts'),
    ratio: LANDSCAPE,
    readings: [
        {key: 'ranger', label: 'Elf ranger', subject: 'an elven ranger in a hooded green cloak, a longbow and a quiver'},
        {key: 'pilot', label: 'Mecha pilot', subject: 'a pilot in a white and orange pressure suit, a helmet under one arm'},
        {key: 'mage', label: 'Cat mage', subject: 'a cat wizard in a star-patterned robe with a knotted wooden staff'},
    ],
    styles: [
        {key: 'line', label: 'Model-sheet line', style: 'a four-view turnaround in clean black line art', palette: 'no shading, plain white ground', framing: 'front, three-quarter, side and back, alignment guides'},
        {key: 'painted', label: 'Fully painted', style: 'a three-view turnaround in polished digital paint', palette: 'rendered fabric, metal and leather', framing: 'front, three-quarter and back, neutral grey'},
        {key: 'chibi', label: 'Chibi expressions', style: 'large-headed chibi busts, cel-shaded', palette: 'clean color on a plain pastel ground', framing: 'a row of six expressions'},
    ],
    directions: ['a dwarf smith instead', 'in muted earth tones', 'with close-up detail insets'],
}
